import React from 'react'
import ModalWrapper from 'components/modals/ModalWrapper'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
const styles = theme => ({})
class NoNetworkModal extends React.Component {
  static propTypes = {
    hideModal: PropTypes.func
  }
  componentDidMount() {}
  render() {
    return (
      <ModalWrapper
        open
        hideModal={this.props.hideModal}
        maxWidth={'sm'}
        title={`Attention - Vérifiez votre connexion internet`}
        cancelText="Fermer"
        showOk={false}>
        <Grid container direction="column" justify="center">
          <Grid item xs={12}>
            <Typography variant="subheading" gutterBottom>
              Il semblerait que vous n'êtes plus connecté à internet. Veuillez
              rétablir la connexion au plus vite.
            </Typography>
            <Typography variant="body1" gutterBottom>
              Astuce 1 : Redmérrarer l'interface réseau de votre terminal<br />
              Astuce 2 : Redémarrer votre box internet<br />
              Astuce 3 : Activer le partage de connexion avec votre mobile
            </Typography>
            <Typography variant="caption" gutterBottom>
              Vous n'êtes pas obligé de rafraichir la page une fois la connexion
              rétablie
            </Typography>
          </Grid>
        </Grid>
      </ModalWrapper>
    )
  }
}

export default withStyles(styles)(NoNetworkModal)



// WEBPACK FOOTER //
// ./src/components/modals/common/NoNetworkModal.js